import React from "react"
import { FaCode, FaAtom, FaChartLine } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Back end web development",
    text: `Providing high-quality backend services for various businesses.Backend is the functional core of website which handles a lot of things
          like databases interactions.I used to work with Laravel and Spring boot.`,
  },
  {
    id: 2,
    icon: <FaAtom className="service-icon" />,
    title: "Data Science",
    text: `Data science is the study of large quantities of data.Collecting data from various online sources
    and Use AI, ML algorithms and deep learning models, to clean and extract insights from these data`,
  },
  {
    id: 3,
    icon: <FaChartLine className="service-icon" />,
    title: "Business Intelligence",
    text: `BI are the applications, infrastructures, tools and practices providing access to information, 
    and allowing to analyze information to improve and optimize decisions and performance
    .Analyzing, visualizing data and develop dashboards and write reports about findings.`,
  },
]
